import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/basic-info/employee-list`;

export const employeeListRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  edit: `${baseRoute}/edit/:employeeId`,
  view: `${baseRoute}/view/:employeeId`,
  warehouseList: `${baseRoute}/:employeeId/warehouses`,
  addNewWarehouse: `${baseRoute}/:employeeId/warehouses/create`,
  resetEmployeePassword: `${baseRoute}/:employeeId/reset`,
} as const;

export type IEmployeeListRouteParams = IExtractRouteParamMap<
  typeof employeeListRoutesObj
>;

export const employeeListPath = createPaths<
  typeof employeeListRoutesObj,
  IEmployeeListRouteParams
>(employeeListRoutesObj);
